module.exports = __webpack_public_path__ + "files/ed95b92cb400c91bafc491b09f0f043d.png";